import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Params} from '@angular/router';
import {Observable, Subscription} from 'rxjs';
import {Store} from '@ngrx/store';
import {CertificateService} from './certificate.service';
import * as fromCertificate from './store/certificate.reducers';
import * as fromApp from '../../store/app.reducers';
import * as CertificateActions from './store/certificate.actions';
import * as ProfileActions from '../store/profile.actions';
import {AuthService} from '../../auth/auth.service';

@Component({
    selector: 'app-certificate',
    templateUrl: './certificate.component.html',
    styleUrls: ['./certificate.component.scss'],
    standalone: false
})
export class CertificateComponent implements OnInit, OnDestroy {

  certificateState: Observable<fromCertificate.State>;
  routeSubscription: Subscription;
  id: number;
  code: string;
  userUid: string;

  constructor(
    private store: Store<fromApp.AppState>,
    private route: ActivatedRoute,
    private certificateService: CertificateService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.userUid = this.certificateService.setCookieForUniqueUser();
    this.certificateState = this.store.select('certificate');
    this.routeSubscription = this.route.params.subscribe(
      (params: Params) => {
        if (params.id !== undefined) {
          this.id = +params.id;
        }
        this.code = params.code;

        this.store.dispatch(
          new CertificateActions.GetCertificateProfileByCode({
            code: this.code
          })
        );
      }
    );
  }

  isAuthenticated() {
    return this.authService.isAuthenticated();
  }

  isCertificateActive() {
    return this.certificateService.isCertificateActive();
  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe();
    this.store.dispatch(
      new ProfileActions.ResetAuditId()
    );
  }

}
